export const qk = {
    lectureAdminRoot : ()  => ['lectureAdmin'],
    lectureAdmin:     (id) => ['lectureAdmin', id],              
    applyList:        (id) => ['lectureAdmin', id, 'applyList'],  
    attendList:       (id) => ['lectureAdmin', id, 'attendList'],
    lectureInfo:      (id) => ['lectureAdmin', id, 'lectureInfo'],
    studentList:      (id) => ['lectureAdmin', id, 'studentList'],
    invoiceList:      (id) => ['lectureAdmin', id, 'invoiceList'],
    invoiceAllList:   ()   => ['lectureAdmin', 'invoiceAllList'],
    


    lectureUser:      (id) => ['lectureUser', id],
    detail:           (id) => ['lectureUser', id, 'detail'],
    applyStatus:      (id) => ['lectureUser', id, 'applyStatus'],
    applyModal:       (id) => ['lectureUser', id, 'applyModal'],

    
  };